// extracted by mini-css-extract-plugin
export default {"date_picker":"MyDatePicker_date_picker__zl3Hc","field_style":"MyDatePicker_field_style__j45tH"};